import { render, staticRenderFns } from "./ExtraCost.vue?vue&type=template&id=98c86e38&scoped=true&"
import script from "./ExtraCost.vue?vue&type=script&lang=js&"
export * from "./ExtraCost.vue?vue&type=script&lang=js&"
import style0 from "./ExtraCost.vue?vue&type=style&index=0&id=98c86e38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c86e38",
  null
  
)

export default component.exports